import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { closePanel } from '@/features/aiChat/aiChatSlice'

/**
 * Below this width the assistant is a full-screen modal sheet over the page
 * instead of a 420px column beside it (DESIGN.md: "a 420px column from
 * 1024px upward"). The one source for every check of that breakpoint: the
 * sheet behaviour, its animations, the spotlight, and the cards that
 * navigate away (E06: a 639px copy left the sheet over the new page at
 * 640-1023px).
 */
export const SHEET_MAX_WIDTH_PX = 1023
export const SHEET_QUERY = `(max-width: ${SHEET_MAX_WIDTH_PX}px)`

/** @returns {boolean} whether the assistant renders as a sheet right now */
export function isSheetWidth() {
  try {
    return Boolean(window.matchMedia(SHEET_QUERY)?.matches)
  } catch {
    return false
  }
}

/**
 * A callback for anything in the assistant that opens another page: where
 * the assistant is a sheet it covers that page, so close it first; where it
 * is a column it stays open beside the page.
 *
 * @returns {() => void}
 */
export function useCloseSheetOnNavigate() {
  const dispatch = useDispatch()
  return useCallback(() => {
    if (isSheetWidth()) dispatch(closePanel())
  }, [dispatch])
}
